import { C as Re } from "./component-B88NZlIm.js";
import { T as Ce } from "./events-CnaEWcY_.js";
import { d as Ge } from "./utilities-D-QcnR4L.js";
function Ze(_) {
  return _ && _.__esModule && Object.prototype.hasOwnProperty.call(_, "default") ? _.default : _;
}
var ee = { exports: {} },
  Ue = ee.exports,
  ke;
function $e() {
  return (
    ke ||
      ((ke = 1),
      (function (_, ae) {
        (function (D, te) {
          _.exports = te();
        })(Ue, function () {
          function D(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          function te(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              ((n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(e, Ee(n.key), n));
            }
          }
          function B(e, t, i) {
            return (
              t && te(e.prototype, t),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              e
            );
          }
          function Ee(e) {
            var t = (function (i, n) {
              if (typeof i != "object" || !i) return i;
              var s = i[Symbol.toPrimitive];
              if (s !== void 0) {
                var a = s.call(i, n);
                if (typeof a != "object") return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
              }
              return String(i);
            })(e, "string");
            return typeof t == "symbol" ? t : t + "";
          }
          function re(e) {
            return (re =
              typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      typeof Symbol == "function" &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  })(e);
          }
          var oe = Date.now();
          function z() {
            var e = {},
              t = !0,
              i = 0,
              n = arguments.length;
            Object.prototype.toString.call(arguments[0]) === "[object Boolean]" &&
              ((t = arguments[0]), i++);
            for (
              var s = function (l) {
                for (var r in l)
                  Object.prototype.hasOwnProperty.call(l, r) &&
                    (t && Object.prototype.toString.call(l[r]) === "[object Object]"
                      ? (e[r] = z(!0, e[r], l[r]))
                      : (e[r] = l[r]));
              };
              i < n;
              i++
            ) {
              var a = arguments[i];
              s(a);
            }
            return e;
          }
          function x(e, t) {
            if (
              ((X(e) || e === window || e === document) && (e = [e]),
              fe(e) || j(e) || (e = [e]),
              ve(e) != 0)
            ) {
              if (fe(e) && !j(e))
                for (var i = e.length, n = 0; n < i && t.call(e[n], e[n], n, e) !== !1; n++);
              else if (j(e)) {
                for (var s in e) if (S(e, s) && t.call(e[s], e[s], s, e) === !1) break;
              }
            }
          }
          function he(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null,
              i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null,
              n = (e[oe] = e[oe] || []),
              s = { all: n, evt: null, found: null };
            return (
              t &&
                i &&
                ve(n) > 0 &&
                x(n, function (a, l) {
                  if (a.eventName == t && a.fn.toString() == i.toString())
                    return ((s.found = !0), (s.evt = l), !1);
                }),
              s
            );
          }
          function L(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
              i = t.onElement,
              n = t.withCallback,
              s = t.avoidDuplicate,
              a = s === void 0 || s,
              l = t.once,
              r = l !== void 0 && l,
              h = t.useCapture,
              o = h !== void 0 && h,
              d = arguments.length > 2 ? arguments[2] : void 0,
              c = i || [];
            function u(g) {
              (m(n) && n.call(d, g, this), r && u.destroy());
            }
            return (
              R(c) && (c = document.querySelectorAll(c)),
              (u.destroy = function () {
                x(c, function (g) {
                  var f = he(g, e, u);
                  (f.found && f.all.splice(f.evt, 1),
                    g.removeEventListener && g.removeEventListener(e, u, o));
                });
              }),
              x(c, function (g) {
                var f = he(g, e, u);
                ((g.addEventListener && a && !f.found) || !a) &&
                  (g.addEventListener(e, u, o), f.all.push({ eventName: e, fn: u }));
              }),
              u
            );
          }
          function v(e, t) {
            x(t.split(" "), function (i) {
              return e.classList.add(i);
            });
          }
          function b(e, t) {
            x(t.split(" "), function (i) {
              return e.classList.remove(i);
            });
          }
          function T(e, t) {
            return e.classList.contains(t);
          }
          function O(e, t) {
            for (; e !== document.body; ) {
              if (!(e = e.parentElement)) return !1;
              if (typeof e.matches == "function" ? e.matches(t) : e.msMatchesSelector(t)) return e;
            }
          }
          function V(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "",
              i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
            if (!e || t === "") return !1;
            if (t === "none") return (m(i) && i(), !1);
            var n = Ae(),
              s = t.split(" ");
            (x(s, function (a) {
              v(e, "g" + a);
            }),
              L(n, {
                onElement: e,
                avoidDuplicate: !1,
                once: !0,
                withCallback: function (a, l) {
                  (x(s, function (r) {
                    b(l, "g" + r);
                  }),
                    m(i) && i());
                },
              }));
          }
          function Z(e) {
            var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
            if (t === "")
              return (
                (e.style.webkitTransform = ""),
                (e.style.MozTransform = ""),
                (e.style.msTransform = ""),
                (e.style.OTransform = ""),
                (e.style.transform = ""),
                !1
              );
            ((e.style.webkitTransform = t),
              (e.style.MozTransform = t),
              (e.style.msTransform = t),
              (e.style.OTransform = t),
              (e.style.transform = t));
          }
          function de(e) {
            e.style.display = "block";
          }
          function ie(e) {
            e.style.display = "none";
          }
          function H(e) {
            var t = document.createDocumentFragment(),
              i = document.createElement("div");
            for (i.innerHTML = e; i.firstChild; ) t.appendChild(i.firstChild);
            return t;
          }
          function ce() {
            return {
              width:
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              height:
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight,
            };
          }
          function Ae() {
            var e,
              t = document.createElement("fakeelement"),
              i = {
                animation: "animationend",
                OAnimation: "oAnimationEnd",
                MozAnimation: "animationend",
                WebkitAnimation: "webkitAnimationEnd",
              };
            for (e in i) if (t.style[e] !== void 0) return i[e];
          }
          function ne(e, t, i, n) {
            if (e()) t();
            else {
              var s;
              i || (i = 100);
              var a = setInterval(function () {
                e() && (clearInterval(a), s && clearTimeout(s), t());
              }, i);
            }
          }
          function ue(e, t, i) {
            if (E(e)) console.error("Inject assets error");
            else if ((m(t) && ((i = t), (t = !1)), R(t) && t in window)) m(i) && i();
            else {
              var n;
              if (e.indexOf(".css") !== -1) {
                if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0)
                  return void (m(i) && i());
                var s = document.getElementsByTagName("head")[0],
                  a = s.querySelectorAll('link[rel="stylesheet"]'),
                  l = document.createElement("link");
                return (
                  (l.rel = "stylesheet"),
                  (l.type = "text/css"),
                  (l.href = e),
                  (l.media = "all"),
                  a ? s.insertBefore(l, a[0]) : s.appendChild(l),
                  void (m(i) && i())
                );
              }
              if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                if (m(i)) {
                  if (R(t))
                    return (
                      ne(
                        function () {
                          return window[t] !== void 0;
                        },
                        function () {
                          i();
                        }
                      ),
                      !1
                    );
                  i();
                }
              } else {
                var r = document.createElement("script");
                ((r.type = "text/javascript"),
                  (r.src = e),
                  (r.onload = function () {
                    if (m(i)) {
                      if (R(t))
                        return (
                          ne(
                            function () {
                              return window[t] !== void 0;
                            },
                            function () {
                              i();
                            }
                          ),
                          !1
                        );
                      i();
                    }
                  }),
                  document.body.appendChild(r));
              }
            }
          }
          function se() {
            return (
              "navigator" in window &&
              window.navigator.userAgent.match(
                /(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i
              )
            );
          }
          function m(e) {
            return typeof e == "function";
          }
          function R(e) {
            return typeof e == "string";
          }
          function X(e) {
            return !(!e || !e.nodeType || e.nodeType != 1);
          }
          function ge(e) {
            return Array.isArray(e);
          }
          function fe(e) {
            return e && e.length && isFinite(e.length);
          }
          function j(e) {
            return re(e) === "object" && e != null && !m(e) && !ge(e);
          }
          function E(e) {
            return e == null;
          }
          function S(e, t) {
            return e !== null && hasOwnProperty.call(e, t);
          }
          function ve(e) {
            if (j(e)) {
              if (e.keys) return e.keys().length;
              var t = 0;
              for (var i in e) S(e, i) && t++;
              return t;
            }
            return e.length;
          }
          function U(e) {
            return !isNaN(parseFloat(e)) && isFinite(e);
          }
          function me() {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1,
              t = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
            if (!t.length) return !1;
            if (t.length == 1) return t[0];
            typeof e == "string" && (e = parseInt(e));
            var i = [];
            x(t, function (r) {
              i.push(r.getAttribute("data-taborder"));
            });
            var n = Math.max.apply(
                Math,
                i.map(function (r) {
                  return parseInt(r);
                })
              ),
              s = e < 0 ? 1 : e + 1;
            s > n && (s = "1");
            var a = i.filter(function (r) {
                return r >= parseInt(s);
              }),
              l = a.sort()[0];
            return document.querySelector('.gbtn[data-taborder="'.concat(l, '"]'));
          }
          function Le(e) {
            if (e.events.hasOwnProperty("keyboard")) return !1;
            e.events.keyboard = L("keydown", {
              onElement: window,
              withCallback: function (t, i) {
                var n = (t = t || window.event).keyCode;
                if (n == 9) {
                  var s = document.querySelector(".gbtn.focused");
                  if (!s) {
                    var a =
                      !(!document.activeElement || !document.activeElement.nodeName) &&
                      document.activeElement.nodeName.toLocaleLowerCase();
                    if (a == "input" || a == "textarea" || a == "button") return;
                  }
                  t.preventDefault();
                  var l = document.querySelectorAll(".gbtn[data-taborder]");
                  if (!l || l.length <= 0) return;
                  if (!s) {
                    var r = me();
                    return void (r && (r.focus(), v(r, "focused")));
                  }
                  var h = me(s.getAttribute("data-taborder"));
                  (b(s, "focused"), h && (h.focus(), v(h, "focused")));
                }
                (n == 39 && e.nextSlide(), n == 37 && e.prevSlide(), n == 27 && e.close());
              },
            });
          }
          var Ie = B(
              function e(t, i) {
                var n = this,
                  s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                if (
                  (D(this, e),
                  (this.img = t),
                  (this.slide = i),
                  (this.onclose = s),
                  this.img.setZoomEvents)
                )
                  return !1;
                ((this.active = !1),
                  (this.zoomedIn = !1),
                  (this.dragging = !1),
                  (this.currentX = null),
                  (this.currentY = null),
                  (this.initialX = null),
                  (this.initialY = null),
                  (this.xOffset = 0),
                  (this.yOffset = 0),
                  this.img.addEventListener(
                    "mousedown",
                    function (a) {
                      return n.dragStart(a);
                    },
                    !1
                  ),
                  this.img.addEventListener(
                    "mouseup",
                    function (a) {
                      return n.dragEnd(a);
                    },
                    !1
                  ),
                  this.img.addEventListener(
                    "mousemove",
                    function (a) {
                      return n.drag(a);
                    },
                    !1
                  ),
                  this.img.addEventListener(
                    "click",
                    function (a) {
                      return n.slide.classList.contains("dragging-nav")
                        ? (n.zoomOut(), !1)
                        : n.zoomedIn
                          ? void (n.zoomedIn && !n.dragging && n.zoomOut())
                          : n.zoomIn();
                    },
                    !1
                  ),
                  (this.img.setZoomEvents = !0));
              },
              [
                {
                  key: "zoomIn",
                  value: function () {
                    var e = this.widowWidth();
                    if (!(this.zoomedIn || e <= 768)) {
                      var t = this.img;
                      if (
                        (t.setAttribute("data-style", t.getAttribute("style")),
                        (t.style.maxWidth = t.naturalWidth + "px"),
                        (t.style.maxHeight = t.naturalHeight + "px"),
                        t.naturalWidth > e)
                      ) {
                        var i = e / 2 - t.naturalWidth / 2;
                        this.setTranslate(this.img.parentNode, i, 0);
                      }
                      (this.slide.classList.add("zoomed"), (this.zoomedIn = !0));
                    }
                  },
                },
                {
                  key: "zoomOut",
                  value: function () {
                    (this.img.parentNode.setAttribute("style", ""),
                      this.img.setAttribute("style", this.img.getAttribute("data-style")),
                      this.slide.classList.remove("zoomed"),
                      (this.zoomedIn = !1),
                      (this.currentX = null),
                      (this.currentY = null),
                      (this.initialX = null),
                      (this.initialY = null),
                      (this.xOffset = 0),
                      (this.yOffset = 0),
                      this.onclose && typeof this.onclose == "function" && this.onclose());
                  },
                },
                {
                  key: "dragStart",
                  value: function (e) {
                    (e.preventDefault(),
                      this.zoomedIn
                        ? (e.type === "touchstart"
                            ? ((this.initialX = e.touches[0].clientX - this.xOffset),
                              (this.initialY = e.touches[0].clientY - this.yOffset))
                            : ((this.initialX = e.clientX - this.xOffset),
                              (this.initialY = e.clientY - this.yOffset)),
                          e.target === this.img &&
                            ((this.active = !0), this.img.classList.add("dragging")))
                        : (this.active = !1));
                  },
                },
                {
                  key: "dragEnd",
                  value: function (e) {
                    var t = this;
                    (e.preventDefault(),
                      (this.initialX = this.currentX),
                      (this.initialY = this.currentY),
                      (this.active = !1),
                      setTimeout(function () {
                        ((t.dragging = !1),
                          (t.img.isDragging = !1),
                          t.img.classList.remove("dragging"));
                      }, 100));
                  },
                },
                {
                  key: "drag",
                  value: function (e) {
                    this.active &&
                      (e.preventDefault(),
                      e.type === "touchmove"
                        ? ((this.currentX = e.touches[0].clientX - this.initialX),
                          (this.currentY = e.touches[0].clientY - this.initialY))
                        : ((this.currentX = e.clientX - this.initialX),
                          (this.currentY = e.clientY - this.initialY)),
                      (this.xOffset = this.currentX),
                      (this.yOffset = this.currentY),
                      (this.img.isDragging = !0),
                      (this.dragging = !0),
                      this.setTranslate(this.img, this.currentX, this.currentY));
                  },
                },
                {
                  key: "onMove",
                  value: function (e) {
                    if (this.zoomedIn) {
                      var t = e.clientX - this.img.naturalWidth / 2,
                        i = e.clientY - this.img.naturalHeight / 2;
                      this.setTranslate(this.img, t, i);
                    }
                  },
                },
                {
                  key: "setTranslate",
                  value: function (e, t, i) {
                    e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)";
                  },
                },
                {
                  key: "widowWidth",
                  value: function () {
                    return (
                      window.innerWidth ||
                      document.documentElement.clientWidth ||
                      document.body.clientWidth
                    );
                  },
                },
              ]
            ),
            pe = B(
              function e() {
                var t = this,
                  i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                D(this, e);
                var n = i.dragEl,
                  s = i.toleranceX,
                  a = s === void 0 ? 40 : s,
                  l = i.toleranceY,
                  r = l === void 0 ? 65 : l,
                  h = i.slide,
                  o = h === void 0 ? null : h,
                  d = i.instance,
                  c = d === void 0 ? null : d;
                ((this.el = n),
                  (this.active = !1),
                  (this.dragging = !1),
                  (this.currentX = null),
                  (this.currentY = null),
                  (this.initialX = null),
                  (this.initialY = null),
                  (this.xOffset = 0),
                  (this.yOffset = 0),
                  (this.direction = null),
                  (this.lastDirection = null),
                  (this.toleranceX = a),
                  (this.toleranceY = r),
                  (this.toleranceReached = !1),
                  (this.dragContainer = this.el),
                  (this.slide = o),
                  (this.instance = c),
                  this.el.addEventListener(
                    "mousedown",
                    function (u) {
                      return t.dragStart(u);
                    },
                    !1
                  ),
                  this.el.addEventListener(
                    "mouseup",
                    function (u) {
                      return t.dragEnd(u);
                    },
                    !1
                  ),
                  this.el.addEventListener(
                    "mousemove",
                    function (u) {
                      return t.drag(u);
                    },
                    !1
                  ));
              },
              [
                {
                  key: "dragStart",
                  value: function (e) {
                    if (this.slide.classList.contains("zoomed")) this.active = !1;
                    else {
                      e.type === "touchstart"
                        ? ((this.initialX = e.touches[0].clientX - this.xOffset),
                          (this.initialY = e.touches[0].clientY - this.yOffset))
                        : ((this.initialX = e.clientX - this.xOffset),
                          (this.initialY = e.clientY - this.yOffset));
                      var t = e.target.nodeName.toLowerCase();
                      e.target.classList.contains("nodrag") ||
                      O(e.target, ".nodrag") ||
                      ["input", "select", "textarea", "button", "a"].indexOf(t) !== -1
                        ? (this.active = !1)
                        : (e.preventDefault(),
                          (e.target === this.el ||
                            (t !== "img" && O(e.target, ".gslide-inline"))) &&
                            ((this.active = !0),
                            this.el.classList.add("dragging"),
                            (this.dragContainer = O(e.target, ".ginner-container"))));
                    }
                  },
                },
                {
                  key: "dragEnd",
                  value: function (e) {
                    var t = this;
                    (e && e.preventDefault(),
                      (this.initialX = 0),
                      (this.initialY = 0),
                      (this.currentX = null),
                      (this.currentY = null),
                      (this.initialX = null),
                      (this.initialY = null),
                      (this.xOffset = 0),
                      (this.yOffset = 0),
                      (this.active = !1),
                      this.doSlideChange &&
                        ((this.instance.preventOutsideClick = !0),
                        this.doSlideChange == "right" && this.instance.prevSlide(),
                        this.doSlideChange == "left" && this.instance.nextSlide()),
                      this.doSlideClose && this.instance.close(),
                      this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0),
                      setTimeout(function () {
                        ((t.instance.preventOutsideClick = !1),
                          (t.toleranceReached = !1),
                          (t.lastDirection = null),
                          (t.dragging = !1),
                          (t.el.isDragging = !1),
                          t.el.classList.remove("dragging"),
                          t.slide.classList.remove("dragging-nav"),
                          (t.dragContainer.style.transform = ""),
                          (t.dragContainer.style.transition = ""));
                      }, 100));
                  },
                },
                {
                  key: "drag",
                  value: function (e) {
                    if (this.active) {
                      (e.preventDefault(),
                        this.slide.classList.add("dragging-nav"),
                        e.type === "touchmove"
                          ? ((this.currentX = e.touches[0].clientX - this.initialX),
                            (this.currentY = e.touches[0].clientY - this.initialY))
                          : ((this.currentX = e.clientX - this.initialX),
                            (this.currentY = e.clientY - this.initialY)),
                        (this.xOffset = this.currentX),
                        (this.yOffset = this.currentY),
                        (this.el.isDragging = !0),
                        (this.dragging = !0),
                        (this.doSlideChange = !1),
                        (this.doSlideClose = !1));
                      var t = Math.abs(this.currentX),
                        i = Math.abs(this.currentY);
                      if (
                        t > 0 &&
                        t >= Math.abs(this.currentY) &&
                        (!this.lastDirection || this.lastDirection == "x")
                      ) {
                        ((this.yOffset = 0),
                          (this.lastDirection = "x"),
                          this.setTranslate(this.dragContainer, this.currentX, 0));
                        var n = this.shouldChange();
                        if (
                          (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n),
                          this.instance.settings.dragAutoSnap && n)
                        )
                          return (
                            (this.instance.preventOutsideClick = !0),
                            (this.toleranceReached = !0),
                            (this.active = !1),
                            (this.instance.preventOutsideClick = !0),
                            this.dragEnd(null),
                            n == "right" && this.instance.prevSlide(),
                            void (n == "left" && this.instance.nextSlide())
                          );
                      }
                      if (
                        this.toleranceY > 0 &&
                        i > 0 &&
                        i >= t &&
                        (!this.lastDirection || this.lastDirection == "y")
                      ) {
                        ((this.xOffset = 0),
                          (this.lastDirection = "y"),
                          this.setTranslate(this.dragContainer, 0, this.currentY));
                        var s = this.shouldClose();
                        return (
                          !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0),
                          void (this.instance.settings.dragAutoSnap && s && this.instance.close())
                        );
                      }
                    }
                  },
                },
                {
                  key: "shouldChange",
                  value: function () {
                    var e = !1;
                    if (Math.abs(this.currentX) >= this.toleranceX) {
                      var t = this.currentX > 0 ? "right" : "left";
                      ((t == "left" && this.slide !== this.slide.parentNode.lastChild) ||
                        (t == "right" && this.slide !== this.slide.parentNode.firstChild)) &&
                        (e = t);
                    }
                    return e;
                  },
                },
                {
                  key: "shouldClose",
                  value: function () {
                    var e = !1;
                    return (Math.abs(this.currentY) >= this.toleranceY && (e = !0), e);
                  },
                },
                {
                  key: "setTranslate",
                  value: function (e, t, i) {
                    var n = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
                    ((e.style.transition = n ? "all .2s ease" : ""),
                      (e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)")));
                  },
                },
              ]
            );
          function Oe(e, t, i, n) {
            var s = e.querySelector(".gslide-media"),
              a = new Image(),
              l = "gSlideTitle_" + i,
              r = "gSlideDesc_" + i;
            (a.addEventListener(
              "load",
              function () {
                m(n) && n();
              },
              !1
            ),
              (a.src = t.href),
              t.sizes != "" && t.srcset != "" && ((a.sizes = t.sizes), (a.srcset = t.srcset)),
              (a.alt = ""),
              E(t.alt) || t.alt === "" || (a.alt = t.alt),
              t.title !== "" && a.setAttribute("aria-labelledby", l),
              t.description !== "" && a.setAttribute("aria-describedby", r),
              t.hasOwnProperty("_hasCustomWidth") && t._hasCustomWidth && (a.style.width = t.width),
              t.hasOwnProperty("_hasCustomHeight") &&
                t._hasCustomHeight &&
                (a.style.height = t.height),
              s.insertBefore(a, s.firstChild));
          }
          function Pe(e, t, i, n) {
            var s = this,
              a = e.querySelector(".ginner-container"),
              l = "gvideo" + i,
              r = e.querySelector(".gslide-media"),
              h = this.getAllPlayers();
            (v(a, "gvideo-container"),
              r.insertBefore(H('<div class="gvideo-wrapper"></div>'), r.firstChild));
            var o = e.querySelector(".gvideo-wrapper");
            ue(this.settings.plyr.css, "Plyr");
            var d = t.href,
              c = t?.videoProvider,
              u = !1;
            ((r.style.maxWidth = t.width),
              ue(this.settings.plyr.js, "Plyr", function () {
                if (
                  (!c && d.match(/vimeo\.com\/([0-9]*)/) && (c = "vimeo"),
                  !c &&
                    (d.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) ||
                      d.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) ||
                      d.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) ||
                      d.match(/(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/)) &&
                    (c = "youtube"),
                  c === "local" || !c)
                ) {
                  c = "local";
                  var g = '<video id="' + l + '" ';
                  ((g += 'style="background:#000; max-width: '.concat(t.width, ';" ')),
                    (g += 'preload="metadata" '),
                    (g += 'x-webkit-airplay="allow" '),
                    (g += "playsinline "),
                    (g += "controls "),
                    (g += 'class="gvideo-local">'),
                    (g += '<source src="'.concat(d, '">')),
                    (u = H((g += "</video>"))));
                }
                var f =
                  u ||
                  H(
                    '<div id="'
                      .concat(l, '" data-plyr-provider="')
                      .concat(c, '" data-plyr-embed-id="')
                      .concat(d, '"></div>')
                  );
                (v(o, "".concat(c, "-video gvideo")),
                  o.appendChild(f),
                  o.setAttribute("data-id", l),
                  o.setAttribute("data-index", i));
                var y = S(s.settings.plyr, "config") ? s.settings.plyr.config : {},
                  I = new Plyr("#" + l, y);
                (I.on("ready", function (A) {
                  ((h[l] = A.detail.plyr), m(n) && n());
                }),
                  ne(
                    function () {
                      return (
                        e.querySelector("iframe") &&
                        e.querySelector("iframe").dataset.ready == "true"
                      );
                    },
                    function () {
                      s.resize(e);
                    }
                  ),
                  I.on("enterfullscreen", ye),
                  I.on("exitfullscreen", ye));
              }));
          }
          function ye(e) {
            var t = O(e.target, ".gslide-media");
            (e.type === "enterfullscreen" && v(t, "fullscreen"),
              e.type === "exitfullscreen" && b(t, "fullscreen"));
          }
          function Me(e, t, i, n) {
            var s,
              a = this,
              l = e.querySelector(".gslide-media"),
              r = !(!S(t, "href") || !t.href) && t.href.split("#").pop().trim(),
              h = !(!S(t, "content") || !t.content) && t.content;
            if (
              h &&
              (R(h) && (s = H('<div class="ginlined-content">'.concat(h, "</div>"))), X(h))
            ) {
              h.style.display == "none" && (h.style.display = "block");
              var o = document.createElement("div");
              ((o.className = "ginlined-content"), o.appendChild(h), (s = o));
            }
            if (r) {
              var d = document.getElementById(r);
              if (!d) return !1;
              var c = d.cloneNode(!0);
              ((c.style.height = t.height),
                (c.style.maxWidth = t.width),
                v(c, "ginlined-content"),
                (s = c));
            }
            if (!s) return (console.error("Unable to append inline slide content", t), !1);
            ((l.style.height = t.height),
              (l.style.width = t.width),
              l.appendChild(s),
              (this.events["inlineclose" + r] = L("click", {
                onElement: l.querySelectorAll(".gtrigger-close"),
                withCallback: function (u) {
                  (u.preventDefault(), a.close());
                },
              })),
              m(n) && n());
          }
          function ze(e, t, i, n) {
            var s = e.querySelector(".gslide-media"),
              a = (function (l) {
                var r = l.url,
                  h = l.allow,
                  o = l.callback,
                  d = l.appendTo,
                  c = document.createElement("iframe");
                return (
                  (c.className = "vimeo-video gvideo"),
                  (c.src = r),
                  (c.style.width = "100%"),
                  (c.style.height = "100%"),
                  h && c.setAttribute("allow", h),
                  (c.onload = function () {
                    ((c.onload = null), v(c, "node-ready"), m(o) && o());
                  }),
                  d && d.appendChild(c),
                  c
                );
              })({ url: t.href, callback: n });
            ((s.parentNode.style.maxWidth = t.width),
              (s.parentNode.style.height = t.height),
              s.appendChild(a));
          }
          var Xe = B(
              function e() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                (D(this, e),
                  (this.defaults = {
                    href: "",
                    sizes: "",
                    srcset: "",
                    title: "",
                    type: "",
                    videoProvider: "",
                    description: "",
                    alt: "",
                    descPosition: "bottom",
                    effect: "",
                    width: "",
                    height: "",
                    content: !1,
                    zoomable: !0,
                    draggable: !0,
                  }),
                  j(t) && (this.defaults = z(this.defaults, t)));
              },
              [
                {
                  key: "sourceType",
                  value: function (e) {
                    var t = e;
                    return (e = e.toLowerCase()).match(
                      /\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/
                    ) !== null
                      ? "image"
                      : e.match(
                            /(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/
                          ) ||
                          e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) ||
                          e.match(
                            /(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/
                          ) ||
                          e.match(
                            /(youtube\.com|youtube-nocookie\.com)\/shorts\/([a-zA-Z0-9\-_]+)/
                          ) ||
                          e.match(/vimeo\.com\/([0-9]*)/) ||
                          e.match(/\.(mp4|ogg|webm|mov)/) !== null
                        ? "video"
                        : e.match(/\.(mp3|wav|wma|aac|ogg)/) !== null
                          ? "audio"
                          : e.indexOf("#") > -1 && t.split("#").pop().trim() !== ""
                            ? "inline"
                            : e.indexOf("goajax=true") > -1
                              ? "ajax"
                              : "external";
                  },
                },
                {
                  key: "parseConfig",
                  value: function (e, t) {
                    var i = this,
                      n = z({ descPosition: t.descPosition }, this.defaults);
                    if (j(e) && !X(e)) {
                      S(e, "type") ||
                        (S(e, "content") && e.content
                          ? (e.type = "inline")
                          : S(e, "href") && (e.type = this.sourceType(e.href)));
                      var s = z(n, e);
                      return (this.setSize(s, t), s);
                    }
                    var a = "",
                      l = e.getAttribute("data-glightbox"),
                      r = e.nodeName.toLowerCase();
                    if (
                      (r === "a" && (a = e.href),
                      r === "img" && ((a = e.src), (n.alt = e.alt)),
                      (n.href = a),
                      x(n, function (g, f) {
                        S(t, f) && f !== "width" && (n[f] = t[f]);
                        var y = e.dataset[f];
                        E(y) || (n[f] = i.sanitizeValue(y));
                      }),
                      n.content && (n.type = "inline"),
                      !n.type && a && (n.type = this.sourceType(a)),
                      E(l))
                    ) {
                      if (!n.title && r == "a") {
                        var h = e.title;
                        E(h) || h === "" || (n.title = h);
                      }
                      if (!n.title && r == "img") {
                        var o = e.alt;
                        E(o) || o === "" || (n.title = o);
                      }
                    } else {
                      var d = [];
                      (x(n, function (g, f) {
                        d.push(";\\s?" + f);
                      }),
                        (d = d.join("\\s?:|")),
                        l.trim() !== "" &&
                          x(n, function (g, f) {
                            var y = l,
                              I = new RegExp("s?" + f + "s?:s?(.*?)(" + d + "s?:|$)"),
                              A = y.match(I);
                            if (A && A.length && A[1]) {
                              var q = A[1].trim().replace(/;\s*$/, "");
                              n[f] = i.sanitizeValue(q);
                            }
                          }));
                    }
                    if (n.description && n.description.substring(0, 1) === ".") {
                      var c;
                      try {
                        c = document.querySelector(n.description).innerHTML;
                      } catch (g) {
                        if (!(g instanceof DOMException)) throw g;
                      }
                      c && (n.description = c);
                    }
                    if (!n.description) {
                      var u = e.querySelector(".glightbox-desc");
                      u && (n.description = u.innerHTML);
                    }
                    return (this.setSize(n, t, e), (this.slideConfig = n), n);
                  },
                },
                {
                  key: "setSize",
                  value: function (e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null,
                      n =
                        e.type == "video" ? this.checkSize(t.videosWidth) : this.checkSize(t.width),
                      s = this.checkSize(t.height);
                    return (
                      (e.width = S(e, "width") && e.width !== "" ? this.checkSize(e.width) : n),
                      (e.height = S(e, "height") && e.height !== "" ? this.checkSize(e.height) : s),
                      i &&
                        e.type == "image" &&
                        ((e._hasCustomWidth = !!i.dataset.width),
                        (e._hasCustomHeight = !!i.dataset.height)),
                      e
                    );
                  },
                },
                {
                  key: "checkSize",
                  value: function (e) {
                    return U(e) ? "".concat(e, "px") : e;
                  },
                },
                {
                  key: "sanitizeValue",
                  value: function (e) {
                    return e !== "true" && e !== "false" ? e : e === "true";
                  },
                },
              ]
            ),
            $ = B(
              function e(t, i, n) {
                (D(this, e), (this.element = t), (this.instance = i), (this.index = n));
              },
              [
                {
                  key: "setContent",
                  value: function () {
                    var e = this,
                      t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                      i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
                    if (T(t, "loaded")) return !1;
                    var n = this.instance.settings,
                      s = this.slideConfig,
                      a = se();
                    m(n.beforeSlideLoad) &&
                      n.beforeSlideLoad({ index: this.index, slide: t, player: !1 });
                    var l = s.type,
                      r = s.descPosition,
                      h = t.querySelector(".gslide-media"),
                      o = t.querySelector(".gslide-title"),
                      d = t.querySelector(".gslide-desc"),
                      c = t.querySelector(".gdesc-inner"),
                      u = i,
                      g = "gSlideTitle_" + this.index,
                      f = "gSlideDesc_" + this.index;
                    if (
                      (m(n.afterSlideLoad) &&
                        (u = function () {
                          (m(i) && i(),
                            n.afterSlideLoad({
                              index: e.index,
                              slide: t,
                              player: e.instance.getSlidePlayerInstance(e.index),
                            }));
                        }),
                      s.title == "" && s.description == ""
                        ? c && c.parentNode.parentNode.removeChild(c.parentNode)
                        : (o && s.title !== ""
                            ? ((o.id = g), (o.innerHTML = s.title))
                            : o.parentNode.removeChild(o),
                          d && s.description !== ""
                            ? ((d.id = f),
                              a && n.moreLength > 0
                                ? ((s.smallDescription = this.slideShortDesc(
                                    s.description,
                                    n.moreLength,
                                    n.moreText
                                  )),
                                  (d.innerHTML = s.smallDescription),
                                  this.descriptionEvents(d, s))
                                : (d.innerHTML = s.description))
                            : d.parentNode.removeChild(d),
                          v(h.parentNode, "desc-".concat(r)),
                          v(c.parentNode, "description-".concat(r))),
                      v(h, "gslide-".concat(l)),
                      v(t, "loaded"),
                      l !== "video")
                    ) {
                      if (l !== "external")
                        return l === "inline"
                          ? (Me.apply(this.instance, [t, s, this.index, u]),
                            void (
                              s.draggable &&
                              new pe({
                                dragEl: t.querySelector(".gslide-inline"),
                                toleranceX: n.dragToleranceX,
                                toleranceY: n.dragToleranceY,
                                slide: t,
                                instance: this.instance,
                              })
                            ))
                          : void (l !== "image"
                              ? m(u) && u()
                              : Oe(t, s, this.index, function () {
                                  var y = t.querySelector("img");
                                  (s.draggable &&
                                    new pe({
                                      dragEl: y,
                                      toleranceX: n.dragToleranceX,
                                      toleranceY: n.dragToleranceY,
                                      slide: t,
                                      instance: e.instance,
                                    }),
                                    s.zoomable &&
                                      y.naturalWidth > y.offsetWidth &&
                                      (v(y, "zoomable"),
                                      new Ie(y, t, function () {
                                        e.instance.resize();
                                      })),
                                    m(u) && u());
                                }));
                      ze.apply(this, [t, s, this.index, u]);
                    } else Pe.apply(this.instance, [t, s, this.index, u]);
                  },
                },
                {
                  key: "slideShortDesc",
                  value: function (e) {
                    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 50,
                      i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2],
                      n = document.createElement("div");
                    n.innerHTML = e;
                    var s = n.innerText,
                      a = i;
                    if ((e = s.trim()).length <= t) return e;
                    var l = e.substr(0, t - 1);
                    return a
                      ? ((n = null), l + '... <a href="#" class="desc-more">' + i + "</a>")
                      : l;
                  },
                },
                {
                  key: "descriptionEvents",
                  value: function (e, t) {
                    var i = this,
                      n = e.querySelector(".desc-more");
                    if (!n) return !1;
                    L("click", {
                      onElement: n,
                      withCallback: function (s, a) {
                        s.preventDefault();
                        var l = document.body,
                          r = O(a, ".gslide-desc");
                        if (!r) return !1;
                        ((r.innerHTML = t.description), v(l, "gdesc-open"));
                        var h = L("click", {
                          onElement: [l, O(r, ".gslide-description")],
                          withCallback: function (o, d) {
                            o.target.nodeName.toLowerCase() !== "a" &&
                              (b(l, "gdesc-open"),
                              v(l, "gdesc-closed"),
                              (r.innerHTML = t.smallDescription),
                              i.descriptionEvents(r, t),
                              setTimeout(function () {
                                b(l, "gdesc-closed");
                              }, 400),
                              h.destroy());
                          },
                        });
                      },
                    });
                  },
                },
                {
                  key: "create",
                  value: function () {
                    return H(this.instance.settings.slideHTML);
                  },
                },
                {
                  key: "getConfig",
                  value: function () {
                    X(this.element) ||
                      this.element.hasOwnProperty("draggable") ||
                      (this.element.draggable = this.instance.settings.draggable);
                    var e = new Xe(this.instance.settings.slideExtraAttributes);
                    return (
                      (this.slideConfig = e.parseConfig(this.element, this.instance.settings)),
                      this.slideConfig
                    );
                  },
                },
              ]
            );
          function J(e) {
            return Math.sqrt(e.x * e.x + e.y * e.y);
          }
          function qe(e, t) {
            var i = (function (n, s) {
              var a = J(n) * J(s);
              if (a === 0) return 0;
              var l =
                (function (r, h) {
                  return r.x * h.x + r.y * h.y;
                })(n, s) / a;
              return (l > 1 && (l = 1), Math.acos(l));
            })(e, t);
            return (
              (function (n, s) {
                return n.x * s.y - s.x * n.y;
              })(e, t) > 0 && (i *= -1),
              (180 * i) / Math.PI
            );
          }
          var Ye = B(
            function e(t) {
              (D(this, e), (this.handlers = []), (this.el = t));
            },
            [
              {
                key: "add",
                value: function (e) {
                  this.handlers.push(e);
                },
              },
              {
                key: "del",
                value: function (e) {
                  e || (this.handlers = []);
                  for (var t = this.handlers.length; t >= 0; t--)
                    this.handlers[t] === e && this.handlers.splice(t, 1);
                },
              },
              {
                key: "dispatch",
                value: function () {
                  for (var e = 0, t = this.handlers.length; e < t; e++) {
                    var i = this.handlers[e];
                    typeof i == "function" && i.apply(this.el, arguments);
                  }
                },
              },
            ]
          );
          function C(e, t) {
            var i = new Ye(e);
            return (i.add(t), i);
          }
          var Ne = B(
            function e(t, i) {
              (D(this, e),
                (this.element = typeof t == "string" ? document.querySelector(t) : t),
                (this.start = this.start.bind(this)),
                (this.move = this.move.bind(this)),
                (this.end = this.end.bind(this)),
                (this.cancel = this.cancel.bind(this)),
                this.element.addEventListener("touchstart", this.start, !1),
                this.element.addEventListener("touchmove", this.move, !1),
                this.element.addEventListener("touchend", this.end, !1),
                this.element.addEventListener("touchcancel", this.cancel, !1),
                (this.preV = { x: null, y: null }),
                (this.pinchStartLen = null),
                (this.zoom = 1),
                (this.isDoubleTap = !1));
              var n = function () {};
              ((this.rotate = C(this.element, i.rotate || n)),
                (this.touchStart = C(this.element, i.touchStart || n)),
                (this.multipointStart = C(this.element, i.multipointStart || n)),
                (this.multipointEnd = C(this.element, i.multipointEnd || n)),
                (this.pinch = C(this.element, i.pinch || n)),
                (this.swipe = C(this.element, i.swipe || n)),
                (this.tap = C(this.element, i.tap || n)),
                (this.doubleTap = C(this.element, i.doubleTap || n)),
                (this.longTap = C(this.element, i.longTap || n)),
                (this.singleTap = C(this.element, i.singleTap || n)),
                (this.pressMove = C(this.element, i.pressMove || n)),
                (this.twoFingerPressMove = C(this.element, i.twoFingerPressMove || n)),
                (this.touchMove = C(this.element, i.touchMove || n)),
                (this.touchEnd = C(this.element, i.touchEnd || n)),
                (this.touchCancel = C(this.element, i.touchCancel || n)),
                (this.translateContainer = this.element),
                (this._cancelAllHandler = this.cancelAll.bind(this)),
                window.addEventListener("scroll", this._cancelAllHandler),
                (this.delta = null),
                (this.last = null),
                (this.now = null),
                (this.tapTimeout = null),
                (this.singleTapTimeout = null),
                (this.longTapTimeout = null),
                (this.swipeTimeout = null),
                (this.x1 = this.x2 = this.y1 = this.y2 = null),
                (this.preTapPosition = { x: null, y: null }));
            },
            [
              {
                key: "start",
                value: function (e) {
                  if (e.touches)
                    if (
                      e.target &&
                      e.target.nodeName &&
                      ["a", "button", "input"].indexOf(e.target.nodeName.toLowerCase()) >= 0
                    )
                      console.log(
                        "ignore drag for this touched element",
                        e.target.nodeName.toLowerCase()
                      );
                    else {
                      ((this.now = Date.now()),
                        (this.x1 = e.touches[0].pageX),
                        (this.y1 = e.touches[0].pageY),
                        (this.delta = this.now - (this.last || this.now)),
                        this.touchStart.dispatch(e, this.element),
                        this.preTapPosition.x !== null &&
                          ((this.isDoubleTap =
                            this.delta > 0 &&
                            this.delta <= 250 &&
                            Math.abs(this.preTapPosition.x - this.x1) < 30 &&
                            Math.abs(this.preTapPosition.y - this.y1) < 30),
                          this.isDoubleTap && clearTimeout(this.singleTapTimeout)),
                        (this.preTapPosition.x = this.x1),
                        (this.preTapPosition.y = this.y1),
                        (this.last = this.now));
                      var t = this.preV;
                      if (e.touches.length > 1) {
                        (this._cancelLongTap(), this._cancelSingleTap());
                        var i = {
                          x: e.touches[1].pageX - this.x1,
                          y: e.touches[1].pageY - this.y1,
                        };
                        ((t.x = i.x),
                          (t.y = i.y),
                          (this.pinchStartLen = J(t)),
                          this.multipointStart.dispatch(e, this.element));
                      }
                      ((this._preventTap = !1),
                        (this.longTapTimeout = setTimeout(
                          function () {
                            (this.longTap.dispatch(e, this.element), (this._preventTap = !0));
                          }.bind(this),
                          750
                        )));
                    }
                },
              },
              {
                key: "move",
                value: function (e) {
                  if (e.touches) {
                    var t = this.preV,
                      i = e.touches.length,
                      n = e.touches[0].pageX,
                      s = e.touches[0].pageY;
                    if (((this.isDoubleTap = !1), i > 1)) {
                      var a = e.touches[1].pageX,
                        l = e.touches[1].pageY,
                        r = { x: e.touches[1].pageX - n, y: e.touches[1].pageY - s };
                      (t.x !== null &&
                        (this.pinchStartLen > 0 &&
                          ((e.zoom = J(r) / this.pinchStartLen),
                          this.pinch.dispatch(e, this.element)),
                        (e.angle = qe(r, t)),
                        this.rotate.dispatch(e, this.element)),
                        (t.x = r.x),
                        (t.y = r.y),
                        this.x2 !== null && this.sx2 !== null
                          ? ((e.deltaX = (n - this.x2 + a - this.sx2) / 2),
                            (e.deltaY = (s - this.y2 + l - this.sy2) / 2))
                          : ((e.deltaX = 0), (e.deltaY = 0)),
                        this.twoFingerPressMove.dispatch(e, this.element),
                        (this.sx2 = a),
                        (this.sy2 = l));
                    } else {
                      if (this.x2 !== null) {
                        ((e.deltaX = n - this.x2), (e.deltaY = s - this.y2));
                        var h = Math.abs(this.x1 - this.x2),
                          o = Math.abs(this.y1 - this.y2);
                        (h > 10 || o > 10) && (this._preventTap = !0);
                      } else ((e.deltaX = 0), (e.deltaY = 0));
                      this.pressMove.dispatch(e, this.element);
                    }
                    (this.touchMove.dispatch(e, this.element),
                      this._cancelLongTap(),
                      (this.x2 = n),
                      (this.y2 = s),
                      i > 1 && e.preventDefault());
                  }
                },
              },
              {
                key: "end",
                value: function (e) {
                  if (e.changedTouches) {
                    this._cancelLongTap();
                    var t = this;
                    (e.touches.length < 2 &&
                      (this.multipointEnd.dispatch(e, this.element), (this.sx2 = this.sy2 = null)),
                      (this.x2 && Math.abs(this.x1 - this.x2) > 30) ||
                      (this.y2 && Math.abs(this.y1 - this.y2) > 30)
                        ? ((e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2)),
                          (this.swipeTimeout = setTimeout(function () {
                            t.swipe.dispatch(e, t.element);
                          }, 0)))
                        : ((this.tapTimeout = setTimeout(function () {
                            (t._preventTap || t.tap.dispatch(e, t.element),
                              t.isDoubleTap &&
                                (t.doubleTap.dispatch(e, t.element), (t.isDoubleTap = !1)));
                          }, 0)),
                          t.isDoubleTap ||
                            (t.singleTapTimeout = setTimeout(function () {
                              t.singleTap.dispatch(e, t.element);
                            }, 250))),
                      this.touchEnd.dispatch(e, this.element),
                      (this.preV.x = 0),
                      (this.preV.y = 0),
                      (this.zoom = 1),
                      (this.pinchStartLen = null),
                      (this.x1 = this.x2 = this.y1 = this.y2 = null));
                  }
                },
              },
              {
                key: "cancelAll",
                value: function () {
                  ((this._preventTap = !0),
                    clearTimeout(this.singleTapTimeout),
                    clearTimeout(this.tapTimeout),
                    clearTimeout(this.longTapTimeout),
                    clearTimeout(this.swipeTimeout));
                },
              },
              {
                key: "cancel",
                value: function (e) {
                  (this.cancelAll(), this.touchCancel.dispatch(e, this.element));
                },
              },
              {
                key: "_cancelLongTap",
                value: function () {
                  clearTimeout(this.longTapTimeout);
                },
              },
              {
                key: "_cancelSingleTap",
                value: function () {
                  clearTimeout(this.singleTapTimeout);
                },
              },
              {
                key: "_swipeDirection",
                value: function (e, t, i, n) {
                  return Math.abs(e - t) >= Math.abs(i - n)
                    ? e - t > 0
                      ? "Left"
                      : "Right"
                    : i - n > 0
                      ? "Up"
                      : "Down";
                },
              },
              {
                key: "on",
                value: function (e, t) {
                  this[e] && this[e].add(t);
                },
              },
              {
                key: "off",
                value: function (e, t) {
                  this[e] && this[e].del(t);
                },
              },
              {
                key: "destroy",
                value: function () {
                  return (
                    this.singleTapTimeout && clearTimeout(this.singleTapTimeout),
                    this.tapTimeout && clearTimeout(this.tapTimeout),
                    this.longTapTimeout && clearTimeout(this.longTapTimeout),
                    this.swipeTimeout && clearTimeout(this.swipeTimeout),
                    this.element.removeEventListener("touchstart", this.start),
                    this.element.removeEventListener("touchmove", this.move),
                    this.element.removeEventListener("touchend", this.end),
                    this.element.removeEventListener("touchcancel", this.cancel),
                    this.rotate.del(),
                    this.touchStart.del(),
                    this.multipointStart.del(),
                    this.multipointEnd.del(),
                    this.pinch.del(),
                    this.swipe.del(),
                    this.tap.del(),
                    this.doubleTap.del(),
                    this.longTap.del(),
                    this.singleTap.del(),
                    this.pressMove.del(),
                    this.twoFingerPressMove.del(),
                    this.touchMove.del(),
                    this.touchEnd.del(),
                    this.touchCancel.del(),
                    (this.preV =
                      this.pinchStartLen =
                      this.zoom =
                      this.isDoubleTap =
                      this.delta =
                      this.last =
                      this.now =
                      this.tapTimeout =
                      this.singleTapTimeout =
                      this.longTapTimeout =
                      this.swipeTimeout =
                      this.x1 =
                      this.x2 =
                      this.y1 =
                      this.y2 =
                      this.preTapPosition =
                      this.rotate =
                      this.touchStart =
                      this.multipointStart =
                      this.multipointEnd =
                      this.pinch =
                      this.swipe =
                      this.tap =
                      this.doubleTap =
                      this.longTap =
                      this.singleTap =
                      this.pressMove =
                      this.touchMove =
                      this.touchEnd =
                      this.touchCancel =
                      this.twoFingerPressMove =
                        null),
                    window.removeEventListener("scroll", this._cancelAllHandler),
                    null
                  );
                },
              },
            ]
          );
          function le(e) {
            var t = (function () {
                var l,
                  r = document.createElement("fakeelement"),
                  h = {
                    transition: "transitionend",
                    OTransition: "oTransitionEnd",
                    MozTransition: "transitionend",
                    WebkitTransition: "webkitTransitionEnd",
                  };
                for (l in h) if (r.style[l] !== void 0) return h[l];
              })(),
              i =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              n = T(e, "gslide-media") ? e : e.querySelector(".gslide-media"),
              s = O(n, ".ginner-container"),
              a = e.querySelector(".gslide-description");
            (i > 769 && (n = s),
              v(n, "greset"),
              Z(n, "translate3d(0, 0, 0)"),
              L(t, {
                onElement: n,
                once: !0,
                withCallback: function (l, r) {
                  b(n, "greset");
                },
              }),
              (n.style.opacity = ""),
              a && (a.style.opacity = ""));
          }
          function _e(e) {
            if (e.events.hasOwnProperty("touch")) return !1;
            var t,
              i,
              n,
              s = ce(),
              a = s.width,
              l = s.height,
              r = !1,
              h = null,
              o = null,
              d = null,
              c = !1,
              u = 1,
              g = 1,
              f = !1,
              y = !1,
              I = null,
              A = null,
              q = null,
              w = null,
              Y = 0,
              N = 0,
              G = !1,
              F = !1,
              P = {},
              M = {},
              we = 0,
              Te = 0,
              Be = document.getElementById("glightbox-slider"),
              K = document.querySelector(".goverlay"),
              He = new Ne(Be, {
                touchStart: function (p) {
                  if (
                    ((r = !0),
                    (T(p.targetTouches[0].target, "ginner-container") ||
                      O(p.targetTouches[0].target, ".gslide-desc") ||
                      p.targetTouches[0].target.nodeName.toLowerCase() == "a") &&
                      (r = !1),
                    O(p.targetTouches[0].target, ".gslide-inline") &&
                      !T(p.targetTouches[0].target.parentNode, "gslide-inline") &&
                      (r = !1),
                    r)
                  ) {
                    if (
                      ((M = p.targetTouches[0]),
                      (P.pageX = p.targetTouches[0].pageX),
                      (P.pageY = p.targetTouches[0].pageY),
                      (we = p.targetTouches[0].clientX),
                      (Te = p.targetTouches[0].clientY),
                      (h = e.activeSlide),
                      (o = h.querySelector(".gslide-media")),
                      (n = h.querySelector(".gslide-inline")),
                      (d = null),
                      T(o, "gslide-image") && (d = o.querySelector("img")),
                      (window.innerWidth ||
                        document.documentElement.clientWidth ||
                        document.body.clientWidth) > 769 &&
                        (o = h.querySelector(".ginner-container")),
                      b(K, "greset"),
                      p.pageX > 20 && p.pageX < window.innerWidth - 20)
                    )
                      return;
                    p.preventDefault();
                  }
                },
                touchMove: function (p) {
                  if (r && ((M = p.targetTouches[0]), !f && !y)) {
                    if (n && n.offsetHeight > l) {
                      var k = P.pageX - M.pageX;
                      if (Math.abs(k) <= 13) return !1;
                    }
                    c = !0;
                    var W,
                      Q = p.targetTouches[0].clientX,
                      Ve = p.targetTouches[0].clientY,
                      je = we - Q,
                      Fe = Te - Ve;
                    if (
                      (Math.abs(je) > Math.abs(Fe) ? ((G = !1), (F = !0)) : ((F = !1), (G = !0)),
                      (t = M.pageX - P.pageX),
                      (Y = (100 * t) / a),
                      (i = M.pageY - P.pageY),
                      (N = (100 * i) / l),
                      G &&
                        d &&
                        ((W = 1 - Math.abs(i) / l),
                        (K.style.opacity = W),
                        e.settings.touchFollowAxis && (Y = 0)),
                      F &&
                        ((W = 1 - Math.abs(t) / a),
                        (o.style.opacity = W),
                        e.settings.touchFollowAxis && (N = 0)),
                      !d)
                    )
                      return Z(o, "translate3d(".concat(Y, "%, 0, 0)"));
                    Z(o, "translate3d(".concat(Y, "%, ").concat(N, "%, 0)"));
                  }
                },
                touchEnd: function () {
                  if (r) {
                    if (((c = !1), y || f)) return ((q = I), void (w = A));
                    var p = Math.abs(parseInt(N)),
                      k = Math.abs(parseInt(Y));
                    if (!(p > 29 && d))
                      return p < 29 && k < 25
                        ? (v(K, "greset"), (K.style.opacity = 1), le(o))
                        : void 0;
                    e.close();
                  }
                },
                multipointEnd: function () {
                  setTimeout(function () {
                    f = !1;
                  }, 50);
                },
                multipointStart: function () {
                  ((f = !0), (u = g || 1));
                },
                pinch: function (p) {
                  if (!d || c) return !1;
                  ((f = !0), (d.scaleX = d.scaleY = u * p.zoom));
                  var k = u * p.zoom;
                  if (((y = !0), k <= 1))
                    return (
                      (y = !1),
                      (k = 1),
                      (w = null),
                      (q = null),
                      (I = null),
                      (A = null),
                      void d.setAttribute("style", "")
                    );
                  (k > 4.5 && (k = 4.5),
                    (d.style.transform = "scale3d(".concat(k, ", ").concat(k, ", 1)")),
                    (g = k));
                },
                pressMove: function (p) {
                  if (y && !f) {
                    var k = M.pageX - P.pageX,
                      W = M.pageY - P.pageY;
                    (q && (k += q), w && (W += w), (I = k), (A = W));
                    var Q = "translate3d(".concat(k, "px, ").concat(W, "px, 0)");
                    (g && (Q += " scale3d(".concat(g, ", ").concat(g, ", 1)")), Z(d, Q));
                  }
                },
                swipe: function (p) {
                  if (!y)
                    if (f) f = !1;
                    else {
                      if (p.direction == "Left") {
                        if (e.index == e.elements.length - 1) return le(o);
                        e.nextSlide();
                      }
                      if (p.direction == "Right") {
                        if (e.index == 0) return le(o);
                        e.prevSlide();
                      }
                    }
                },
              });
            e.events.touch = He;
          }
          var xe = se(),
            be =
              se() !== null ||
              document.createTouch !== void 0 ||
              "ontouchstart" in window ||
              "onmsgesturechange" in window ||
              navigator.msMaxTouchPoints,
            Se = document.getElementsByTagName("html")[0],
            De = {
              selector: ".glightbox",
              elements: null,
              skin: "clean",
              theme: "clean",
              closeButton: !0,
              startAt: null,
              autoplayVideos: !0,
              autofocusVideos: !0,
              descPosition: "bottom",
              width: "900px",
              height: "506px",
              videosWidth: "960px",
              beforeSlideChange: null,
              afterSlideChange: null,
              beforeSlideLoad: null,
              afterSlideLoad: null,
              slideInserted: null,
              slideRemoved: null,
              slideExtraAttributes: null,
              onOpen: null,
              onClose: null,
              loop: !1,
              zoomable: !0,
              draggable: !0,
              dragAutoSnap: !1,
              dragToleranceX: 40,
              dragToleranceY: 65,
              preload: !0,
              oneSlidePerOpen: !1,
              touchNavigation: !0,
              touchFollowAxis: !0,
              keyboardNavigation: !0,
              closeOnOutsideClick: !0,
              plugins: !1,
              plyr: {
                css: "https://cdn.plyr.io/3.6.12/plyr.css",
                js: "https://cdn.plyr.io/3.6.12/plyr.js",
                config: {
                  ratio: "16:9",
                  fullscreen: { enabled: !0, iosNative: !0 },
                  youtube: { noCookie: !0, rel: 0, showinfo: 0, iv_load_policy: 3 },
                  vimeo: { byline: !1, portrait: !1, title: !1, transparent: !1 },
                },
              },
              openEffect: "zoom",
              closeEffect: "zoom",
              slideEffect: "slide",
              moreText: "See more",
              moreLength: 60,
              cssEfects: {
                fade: { in: "fadeIn", out: "fadeOut" },
                zoom: { in: "zoomIn", out: "zoomOut" },
                slide: { in: "slideInRight", out: "slideOutLeft" },
                slideBack: { in: "slideInLeft", out: "slideOutRight" },
                none: { in: "none", out: "none" },
              },
              svg: {
                close:
                  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
                next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
                prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>',
              },
              slideHTML: `<div class="gslide">
    <div class="gslide-inner-content">
        <div class="ginner-container">
            <div class="gslide-media">
            </div>
            <div class="gslide-description">
                <div class="gdesc-inner">
                    <h4 class="gslide-title"></h4>
                    <div class="gslide-desc"></div>
                </div>
            </div>
        </div>
    </div>
</div>`,
              lightboxHTML: `<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
    <div id="glightbox-slider" class="gslider"></div>
    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>
    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>
    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>
</div>
</div>`,
            },
            We = B(
              function e() {
                var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                (D(this, e),
                  (this.customOptions = t),
                  (this.settings = z(De, t)),
                  (this.effectsClasses = this.getAnimationClasses()),
                  (this.videoPlayers = {}),
                  (this.apiEvents = []),
                  (this.fullElementsList = !1));
              },
              [
                {
                  key: "init",
                  value: function () {
                    var e = this,
                      t = this.getSelector();
                    (t &&
                      (this.baseEvents = L("click", {
                        onElement: t,
                        withCallback: function (i, n) {
                          (i.preventDefault(), e.open(n));
                        },
                      })),
                      (this.elements = this.getElements()));
                  },
                },
                {
                  key: "open",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null,
                      t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                    if (this.elements.length === 0) return !1;
                    ((this.activeSlide = null),
                      (this.prevActiveSlideIndex = null),
                      (this.prevActiveSlide = null));
                    var i = U(t) ? t : this.settings.startAt;
                    if (X(e)) {
                      var n = e.getAttribute("data-gallery");
                      (n &&
                        ((this.fullElementsList = this.elements),
                        (this.elements = this.getGalleryElements(this.elements, n))),
                        E(i) && (i = this.getElementIndex(e)) < 0 && (i = 0));
                    }
                    (U(i) || (i = 0),
                      this.build(),
                      V(
                        this.overlay,
                        this.settings.openEffect === "none"
                          ? "none"
                          : this.settings.cssEfects.fade.in
                      ));
                    var s = document.body,
                      a = window.innerWidth - document.documentElement.clientWidth;
                    if (a > 0) {
                      var l = document.createElement("style");
                      ((l.type = "text/css"),
                        (l.className = "gcss-styles"),
                        (l.innerText = ".gscrollbar-fixer {margin-right: ".concat(a, "px}")),
                        document.head.appendChild(l),
                        v(s, "gscrollbar-fixer"));
                    }
                    (v(s, "glightbox-open"),
                      v(Se, "glightbox-open"),
                      xe &&
                        (v(document.body, "glightbox-mobile"),
                        (this.settings.slideEffect = "slide")),
                      this.showSlide(i, !0),
                      this.elements.length === 1
                        ? (v(this.prevButton, "glightbox-button-hidden"),
                          v(this.nextButton, "glightbox-button-hidden"))
                        : (b(this.prevButton, "glightbox-button-hidden"),
                          b(this.nextButton, "glightbox-button-hidden")),
                      (this.lightboxOpen = !0),
                      this.trigger("open"),
                      m(this.settings.onOpen) && this.settings.onOpen(),
                      be && this.settings.touchNavigation && _e(this),
                      this.settings.keyboardNavigation && Le(this));
                  },
                },
                {
                  key: "openAt",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                    this.open(null, e);
                  },
                },
                {
                  key: "showSlide",
                  value: function () {
                    var e = this,
                      t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0,
                      i = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
                    (de(this.loader), (this.index = parseInt(t)));
                    var n = this.slidesContainer.querySelector(".current");
                    (n && b(n, "current"), this.slideAnimateOut());
                    var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                    if (T(s, "loaded")) (this.slideAnimateIn(s, i), ie(this.loader));
                    else {
                      de(this.loader);
                      var a = this.elements[t],
                        l = {
                          index: this.index,
                          slide: s,
                          slideNode: s,
                          slideConfig: a.slideConfig,
                          slideIndex: this.index,
                          trigger: a.node,
                          player: null,
                        };
                      (this.trigger("slide_before_load", l),
                        a.instance.setContent(s, function () {
                          (ie(e.loader),
                            e.resize(),
                            e.slideAnimateIn(s, i),
                            e.trigger("slide_after_load", l));
                        }));
                    }
                    ((this.slideDescription = s.querySelector(".gslide-description")),
                      (this.slideDescriptionContained =
                        this.slideDescription &&
                        T(this.slideDescription.parentNode, "gslide-media")),
                      this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)),
                      this.updateNavigationClasses(),
                      (this.activeSlide = s));
                  },
                },
                {
                  key: "preloadSlide",
                  value: function (e) {
                    var t = this;
                    if (e < 0 || e > this.elements.length - 1 || E(this.elements[e])) return !1;
                    var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                    if (T(i, "loaded")) return !1;
                    var n = this.elements[e],
                      s = n.type,
                      a = {
                        index: e,
                        slide: i,
                        slideNode: i,
                        slideConfig: n.slideConfig,
                        slideIndex: e,
                        trigger: n.node,
                        player: null,
                      };
                    (this.trigger("slide_before_load", a),
                      s === "video" || s === "external"
                        ? setTimeout(function () {
                            n.instance.setContent(i, function () {
                              t.trigger("slide_after_load", a);
                            });
                          }, 200)
                        : n.instance.setContent(i, function () {
                            t.trigger("slide_after_load", a);
                          }));
                  },
                },
                {
                  key: "prevSlide",
                  value: function () {
                    this.goToSlide(this.index - 1);
                  },
                },
                {
                  key: "nextSlide",
                  value: function () {
                    this.goToSlide(this.index + 1);
                  },
                },
                {
                  key: "goToSlide",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
                    if (
                      ((this.prevActiveSlide = this.activeSlide),
                      (this.prevActiveSlideIndex = this.index),
                      !this.loop() && (e < 0 || e > this.elements.length - 1))
                    )
                      return !1;
                    (e < 0 ? (e = this.elements.length - 1) : e >= this.elements.length && (e = 0),
                      this.showSlide(e));
                  },
                },
                {
                  key: "insertSlide",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
                      t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                    t < 0 && (t = this.elements.length);
                    var i = new $(e, this, t),
                      n = i.getConfig(),
                      s = z({}, n),
                      a = i.create(),
                      l = this.elements.length - 1;
                    ((s.index = t),
                      (s.node = !1),
                      (s.instance = i),
                      (s.slideConfig = n),
                      this.elements.splice(t, 0, s));
                    var r = null,
                      h = null;
                    if (this.slidesContainer) {
                      if (t > l) this.slidesContainer.appendChild(a);
                      else {
                        var o = this.slidesContainer.querySelectorAll(".gslide")[t];
                        this.slidesContainer.insertBefore(a, o);
                      }
                      (((this.settings.preload && this.index == 0 && t == 0) ||
                        this.index - 1 == t ||
                        this.index + 1 == t) &&
                        this.preloadSlide(t),
                        this.index === 0 && t === 0 && (this.index = 1),
                        this.updateNavigationClasses(),
                        (r = this.slidesContainer.querySelectorAll(".gslide")[t]),
                        (h = this.getSlidePlayerInstance(t)),
                        (s.slideNode = r));
                    }
                    (this.trigger("slide_inserted", {
                      index: t,
                      slide: r,
                      slideNode: r,
                      slideConfig: n,
                      slideIndex: t,
                      trigger: null,
                      player: h,
                    }),
                      m(this.settings.slideInserted) &&
                        this.settings.slideInserted({ index: t, slide: r, player: h }));
                  },
                },
                {
                  key: "removeSlide",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
                    if (e < 0 || e > this.elements.length - 1) return !1;
                    var t =
                      this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                    (t &&
                      (this.getActiveSlideIndex() == e &&
                        (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()),
                      t.parentNode.removeChild(t)),
                      this.elements.splice(e, 1),
                      this.trigger("slide_removed", e),
                      m(this.settings.slideRemoved) && this.settings.slideRemoved(e));
                  },
                },
                {
                  key: "slideAnimateIn",
                  value: function (e, t) {
                    var i = this,
                      n = e.querySelector(".gslide-media"),
                      s = e.querySelector(".gslide-description"),
                      a = {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        slideNode: this.prevActiveSlide,
                        slideIndex: this.prevActiveSlide,
                        slideConfig: E(this.prevActiveSlideIndex)
                          ? null
                          : this.elements[this.prevActiveSlideIndex].slideConfig,
                        trigger: E(this.prevActiveSlideIndex)
                          ? null
                          : this.elements[this.prevActiveSlideIndex].node,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex),
                      },
                      l = {
                        index: this.index,
                        slide: this.activeSlide,
                        slideNode: this.activeSlide,
                        slideConfig: this.elements[this.index].slideConfig,
                        slideIndex: this.index,
                        trigger: this.elements[this.index].node,
                        player: this.getSlidePlayerInstance(this.index),
                      };
                    if (
                      (n.offsetWidth > 0 && s && (ie(s), (s.style.display = "")),
                      b(e, this.effectsClasses),
                      t)
                    )
                      V(e, this.settings.cssEfects[this.settings.openEffect].in, function () {
                        (i.settings.autoplayVideos && i.slidePlayerPlay(e),
                          i.trigger("slide_changed", { prev: a, current: l }),
                          m(i.settings.afterSlideChange) &&
                            i.settings.afterSlideChange.apply(i, [a, l]));
                      });
                    else {
                      var r = this.settings.slideEffect,
                        h = r !== "none" ? this.settings.cssEfects[r].in : r;
                      (this.prevActiveSlideIndex > this.index &&
                        this.settings.slideEffect == "slide" &&
                        (h = this.settings.cssEfects.slideBack.in),
                        V(e, h, function () {
                          (i.settings.autoplayVideos && i.slidePlayerPlay(e),
                            i.trigger("slide_changed", { prev: a, current: l }),
                            m(i.settings.afterSlideChange) &&
                              i.settings.afterSlideChange.apply(i, [a, l]));
                        }));
                    }
                    (setTimeout(function () {
                      i.resize(e);
                    }, 100),
                      v(e, "current"));
                  },
                },
                {
                  key: "slideAnimateOut",
                  value: function () {
                    if (!this.prevActiveSlide) return !1;
                    var e = this.prevActiveSlide;
                    (b(e, this.effectsClasses), v(e, "prev"));
                    var t = this.settings.slideEffect,
                      i = t !== "none" ? this.settings.cssEfects[t].out : t;
                    (this.slidePlayerPause(e),
                      this.trigger("slide_before_change", {
                        prev: {
                          index: this.prevActiveSlideIndex,
                          slide: this.prevActiveSlide,
                          slideNode: this.prevActiveSlide,
                          slideIndex: this.prevActiveSlideIndex,
                          slideConfig: E(this.prevActiveSlideIndex)
                            ? null
                            : this.elements[this.prevActiveSlideIndex].slideConfig,
                          trigger: E(this.prevActiveSlideIndex)
                            ? null
                            : this.elements[this.prevActiveSlideIndex].node,
                          player: this.getSlidePlayerInstance(this.prevActiveSlideIndex),
                        },
                        current: {
                          index: this.index,
                          slide: this.activeSlide,
                          slideNode: this.activeSlide,
                          slideIndex: this.index,
                          slideConfig: this.elements[this.index].slideConfig,
                          trigger: this.elements[this.index].node,
                          player: this.getSlidePlayerInstance(this.index),
                        },
                      }),
                      m(this.settings.beforeSlideChange) &&
                        this.settings.beforeSlideChange.apply(this, [
                          {
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex),
                          },
                          {
                            index: this.index,
                            slide: this.activeSlide,
                            player: this.getSlidePlayerInstance(this.index),
                          },
                        ]),
                      this.prevActiveSlideIndex > this.index &&
                        this.settings.slideEffect == "slide" &&
                        (i = this.settings.cssEfects.slideBack.out),
                      V(e, i, function () {
                        var n = e.querySelector(".ginner-container"),
                          s = e.querySelector(".gslide-media"),
                          a = e.querySelector(".gslide-description");
                        ((n.style.transform = ""),
                          (s.style.transform = ""),
                          b(s, "greset"),
                          (s.style.opacity = ""),
                          a && (a.style.opacity = ""),
                          b(e, "prev"));
                      }));
                  },
                },
                {
                  key: "getAllPlayers",
                  value: function () {
                    return this.videoPlayers;
                  },
                },
                {
                  key: "getSlidePlayerInstance",
                  value: function (e) {
                    var t = "gvideo" + e,
                      i = this.getAllPlayers();
                    return !(!S(i, t) || !i[t]) && i[t];
                  },
                },
                {
                  key: "stopSlideVideo",
                  value: function (e) {
                    if (X(e)) {
                      var t = e.querySelector(".gvideo-wrapper");
                      t && (e = t.getAttribute("data-index"));
                    }
                    console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                  },
                },
                {
                  key: "slidePlayerPause",
                  value: function (e) {
                    if (X(e)) {
                      var t = e.querySelector(".gvideo-wrapper");
                      t && (e = t.getAttribute("data-index"));
                    }
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                  },
                },
                {
                  key: "playSlideVideo",
                  value: function (e) {
                    if (X(e)) {
                      var t = e.querySelector(".gvideo-wrapper");
                      t && (e = t.getAttribute("data-index"));
                    }
                    console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                    var i = this.getSlidePlayerInstance(e);
                    i && !i.playing && i.play();
                  },
                },
                {
                  key: "slidePlayerPlay",
                  value: function (e) {
                    var t;
                    if (
                      !xe ||
                      ((t = this.settings.plyr.config) !== null && t !== void 0 && t.muted)
                    ) {
                      if (X(e)) {
                        var i = e.querySelector(".gvideo-wrapper");
                        i && (e = i.getAttribute("data-index"));
                      }
                      var n = this.getSlidePlayerInstance(e);
                      n &&
                        !n.playing &&
                        (n.play(), this.settings.autofocusVideos && n.elements.container.focus());
                    }
                  },
                },
                {
                  key: "setElements",
                  value: function (e) {
                    var t = this;
                    this.settings.elements = !1;
                    var i = [];
                    (e &&
                      e.length &&
                      x(e, function (n, s) {
                        var a = new $(n, t, s),
                          l = a.getConfig(),
                          r = z({}, l);
                        ((r.slideConfig = l), (r.instance = a), (r.index = s), i.push(r));
                      }),
                      (this.elements = i),
                      this.lightboxOpen &&
                        ((this.slidesContainer.innerHTML = ""),
                        this.elements.length &&
                          (x(this.elements, function () {
                            var n = H(t.settings.slideHTML);
                            t.slidesContainer.appendChild(n);
                          }),
                          this.showSlide(0, !0))));
                  },
                },
                {
                  key: "getElementIndex",
                  value: function (e) {
                    var t = !1;
                    return (
                      x(this.elements, function (i, n) {
                        if (S(i, "node") && i.node == e) return ((t = n), !0);
                      }),
                      t
                    );
                  },
                },
                {
                  key: "getElements",
                  value: function () {
                    var e = this,
                      t = [];
                    ((this.elements = this.elements ? this.elements : []),
                      !E(this.settings.elements) &&
                        ge(this.settings.elements) &&
                        this.settings.elements.length &&
                        x(this.settings.elements, function (n, s) {
                          var a = new $(n, e, s),
                            l = a.getConfig(),
                            r = z({}, l);
                          ((r.node = !1),
                            (r.index = s),
                            (r.instance = a),
                            (r.slideConfig = l),
                            t.push(r));
                        }));
                    var i = !1;
                    return (
                      this.getSelector() && (i = document.querySelectorAll(this.getSelector())),
                      i &&
                        x(i, function (n, s) {
                          var a = new $(n, e, s),
                            l = a.getConfig(),
                            r = z({}, l);
                          ((r.node = n),
                            (r.index = s),
                            (r.instance = a),
                            (r.slideConfig = l),
                            (r.gallery = n.getAttribute("data-gallery")),
                            t.push(r));
                        }),
                      t
                    );
                  },
                },
                {
                  key: "getGalleryElements",
                  value: function (e, t) {
                    return e.filter(function (i) {
                      return i.gallery == t;
                    });
                  },
                },
                {
                  key: "getSelector",
                  value: function () {
                    return (
                      !this.settings.elements &&
                      (this.settings.selector && this.settings.selector.substring(0, 5) == "data-"
                        ? "*[".concat(this.settings.selector, "]")
                        : this.settings.selector)
                    );
                  },
                },
                {
                  key: "getActiveSlide",
                  value: function () {
                    return this.slidesContainer.querySelectorAll(".gslide")[this.index];
                  },
                },
                {
                  key: "getActiveSlideIndex",
                  value: function () {
                    return this.index;
                  },
                },
                {
                  key: "getAnimationClasses",
                  value: function () {
                    var e = [];
                    for (var t in this.settings.cssEfects)
                      if (this.settings.cssEfects.hasOwnProperty(t)) {
                        var i = this.settings.cssEfects[t];
                        (e.push("g".concat(i.in)), e.push("g".concat(i.out)));
                      }
                    return e.join(" ");
                  },
                },
                {
                  key: "build",
                  value: function () {
                    var e = this;
                    if (this.built) return !1;
                    var t = document.body.childNodes,
                      i = [];
                    x(t, function (o) {
                      o.parentNode == document.body &&
                        o.nodeName.charAt(0) !== "#" &&
                        o.hasAttribute &&
                        !o.hasAttribute("aria-hidden") &&
                        (i.push(o), o.setAttribute("aria-hidden", "true"));
                    });
                    var n = S(this.settings.svg, "next") ? this.settings.svg.next : "",
                      s = S(this.settings.svg, "prev") ? this.settings.svg.prev : "",
                      a = S(this.settings.svg, "close") ? this.settings.svg.close : "",
                      l = this.settings.lightboxHTML;
                    ((l = H(
                      (l = (l = (l = l.replace(/{nextSVG}/g, n)).replace(/{prevSVG}/g, s)).replace(
                        /{closeSVG}/g,
                        a
                      ))
                    )),
                      document.body.appendChild(l));
                    var r = document.getElementById("glightbox-body");
                    this.modal = r;
                    var h = r.querySelector(".gclose");
                    ((this.prevButton = r.querySelector(".gprev")),
                      (this.nextButton = r.querySelector(".gnext")),
                      (this.overlay = r.querySelector(".goverlay")),
                      (this.loader = r.querySelector(".gloader")),
                      (this.slidesContainer = document.getElementById("glightbox-slider")),
                      (this.bodyHiddenChildElms = i),
                      (this.events = {}),
                      v(this.modal, "glightbox-" + this.settings.skin),
                      this.settings.closeButton &&
                        h &&
                        (this.events.close = L("click", {
                          onElement: h,
                          withCallback: function (o, d) {
                            (o.preventDefault(), e.close());
                          },
                        })),
                      h && !this.settings.closeButton && h.parentNode.removeChild(h),
                      this.nextButton &&
                        (this.events.next = L("click", {
                          onElement: this.nextButton,
                          withCallback: function (o, d) {
                            (o.preventDefault(), e.nextSlide());
                          },
                        })),
                      this.prevButton &&
                        (this.events.prev = L("click", {
                          onElement: this.prevButton,
                          withCallback: function (o, d) {
                            (o.preventDefault(), e.prevSlide());
                          },
                        })),
                      this.settings.closeOnOutsideClick &&
                        (this.events.outClose = L("click", {
                          onElement: r,
                          withCallback: function (o, d) {
                            e.preventOutsideClick ||
                              T(document.body, "glightbox-mobile") ||
                              O(o.target, ".ginner-container") ||
                              O(o.target, ".gbtn") ||
                              T(o.target, "gnext") ||
                              T(o.target, "gprev") ||
                              e.close();
                          },
                        })),
                      x(this.elements, function (o, d) {
                        (e.slidesContainer.appendChild(o.instance.create()),
                          (o.slideNode = e.slidesContainer.querySelectorAll(".gslide")[d]));
                      }),
                      be && v(document.body, "glightbox-touch"),
                      (this.events.resize = L("resize", {
                        onElement: window,
                        withCallback: function () {
                          e.resize();
                        },
                      })),
                      (this.built = !0));
                  },
                },
                {
                  key: "resize",
                  value: function () {
                    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
                    if ((e = e || this.activeSlide) && !T(e, "zoomed")) {
                      var t = ce(),
                        i = e.querySelector(".gvideo-wrapper"),
                        n = e.querySelector(".gslide-image"),
                        s = this.slideDescription,
                        a = t.width,
                        l = t.height;
                      if (
                        (a <= 768
                          ? v(document.body, "glightbox-mobile")
                          : b(document.body, "glightbox-mobile"),
                        i || n)
                      ) {
                        var r = !1;
                        if (
                          (s &&
                            (T(s, "description-bottom") || T(s, "description-top")) &&
                            !T(s, "gabsolute") &&
                            (r = !0),
                          n)
                        ) {
                          if (a <= 768) n.querySelector("img");
                          else if (r) {
                            var h,
                              o,
                              d = s.offsetHeight,
                              c = n.querySelector("img"),
                              u =
                                (h = this.elements[this.index]) === null || h === void 0
                                  ? void 0
                                  : h.node,
                              g = "100vh";
                            (u &&
                              (g =
                                (o = u.getAttribute("data-height")) !== null && o !== void 0
                                  ? o
                                  : g),
                              c.setAttribute(
                                "style",
                                "max-height: calc(".concat(g, " - ").concat(d, "px)")
                              ),
                              s.setAttribute("style", "max-width: ".concat(c.offsetWidth, "px;")));
                          }
                        }
                        if (i) {
                          var f = S(this.settings.plyr.config, "ratio")
                            ? this.settings.plyr.config.ratio
                            : "";
                          if (!f) {
                            var y = i.clientWidth,
                              I = i.clientHeight,
                              A = y / I;
                            f = "".concat(y / A, ":").concat(I / A);
                          }
                          var q = f.split(":"),
                            w = this.settings.videosWidth,
                            Y = this.settings.videosWidth,
                            N =
                              (Y =
                                U(w) || w.indexOf("px") !== -1
                                  ? parseInt(w)
                                  : w.indexOf("vw") !== -1
                                    ? (a * parseInt(w)) / 100
                                    : w.indexOf("vh") !== -1
                                      ? (l * parseInt(w)) / 100
                                      : w.indexOf("%") !== -1
                                        ? (a * parseInt(w)) / 100
                                        : parseInt(i.clientWidth)) /
                              (parseInt(q[0]) / parseInt(q[1]));
                          if (
                            ((N = Math.floor(N)),
                            r && (l -= s.offsetHeight),
                            Y > a || N > l || (l < N && a > Y))
                          ) {
                            var G = i.offsetWidth,
                              F = i.offsetHeight,
                              P = l / F,
                              M = { width: G * P, height: F * P };
                            (i.parentNode.setAttribute(
                              "style",
                              "max-width: ".concat(M.width, "px")
                            ),
                              r && s.setAttribute("style", "max-width: ".concat(M.width, "px;")));
                          } else
                            ((i.parentNode.style.maxWidth = "".concat(w)),
                              r && s.setAttribute("style", "max-width: ".concat(w, ";")));
                        }
                      }
                    }
                  },
                },
                {
                  key: "reload",
                  value: function () {
                    this.init();
                  },
                },
                {
                  key: "updateNavigationClasses",
                  value: function () {
                    var e = this.loop();
                    (b(this.nextButton, "disabled"),
                      b(this.prevButton, "disabled"),
                      this.index == 0 && this.elements.length - 1 == 0
                        ? (v(this.prevButton, "disabled"), v(this.nextButton, "disabled"))
                        : this.index !== 0 || e
                          ? this.index !== this.elements.length - 1 ||
                            e ||
                            v(this.nextButton, "disabled")
                          : v(this.prevButton, "disabled"));
                  },
                },
                {
                  key: "loop",
                  value: function () {
                    var e = S(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                    return ((e = S(this.settings, "loop") ? this.settings.loop : e), e);
                  },
                },
                {
                  key: "close",
                  value: function () {
                    var e = this;
                    if (!this.lightboxOpen) {
                      if (this.events) {
                        for (var t in this.events)
                          this.events.hasOwnProperty(t) && this.events[t].destroy();
                        this.events = null;
                      }
                      return !1;
                    }
                    if (this.closing) return !1;
                    ((this.closing = !0),
                      this.slidePlayerPause(this.activeSlide),
                      this.fullElementsList && (this.elements = this.fullElementsList),
                      this.bodyHiddenChildElms.length &&
                        x(this.bodyHiddenChildElms, function (i) {
                          i.removeAttribute("aria-hidden");
                        }),
                      v(this.modal, "glightbox-closing"),
                      V(
                        this.overlay,
                        this.settings.openEffect == "none"
                          ? "none"
                          : this.settings.cssEfects.fade.out
                      ),
                      V(
                        this.activeSlide,
                        this.settings.cssEfects[this.settings.closeEffect].out,
                        function () {
                          if (
                            ((e.activeSlide = null),
                            (e.prevActiveSlideIndex = null),
                            (e.prevActiveSlide = null),
                            (e.built = !1),
                            e.events)
                          ) {
                            for (var i in e.events)
                              e.events.hasOwnProperty(i) && e.events[i].destroy();
                            e.events = null;
                          }
                          var n = document.body;
                          (b(Se, "glightbox-open"),
                            b(
                              n,
                              "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"
                            ),
                            e.modal.parentNode.removeChild(e.modal),
                            e.trigger("close"),
                            m(e.settings.onClose) && e.settings.onClose());
                          var s = document.querySelector(".gcss-styles");
                          (s && s.parentNode.removeChild(s),
                            (e.lightboxOpen = !1),
                            (e.closing = null));
                        }
                      ));
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    (this.close(),
                      this.clearAllEvents(),
                      this.baseEvents && this.baseEvents.destroy());
                  },
                },
                {
                  key: "on",
                  value: function (e, t) {
                    var i = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
                    if (!e || !m(t)) throw new TypeError("Event name and callback must be defined");
                    this.apiEvents.push({ evt: e, once: i, callback: t });
                  },
                },
                {
                  key: "once",
                  value: function (e, t) {
                    this.on(e, t, !0);
                  },
                },
                {
                  key: "trigger",
                  value: function (e) {
                    var t = this,
                      i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null,
                      n = [];
                    (x(this.apiEvents, function (s, a) {
                      var l = s.evt,
                        r = s.once,
                        h = s.callback;
                      l == e && (h(i), r && n.push(a));
                    }),
                      n.length &&
                        x(n, function (s) {
                          return t.apiEvents.splice(s, 1);
                        }));
                  },
                },
                {
                  key: "clearAllEvents",
                  value: function () {
                    this.apiEvents.splice(0, this.apiEvents.length);
                  },
                },
                {
                  key: "version",
                  value: function () {
                    return "3.3.1";
                  },
                },
              ]
            );
          return function () {
            var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
              t = new We(e);
            return (t.init(), t);
          };
        });
      })(ee)),
    ee.exports
  );
}
var Je = $e();
const Ke = Ze(Je);
class Qe extends Re {
  #e = null;
  #t;
  connectedCallback() {
    (super.connectedCallback(),
      this.#i(),
      (this.#t = this.#n.bind(this)),
      document.addEventListener(Ce.variantUpdate, this.#t));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.#e?.destroy(),
      (this.#e = null),
      document.removeEventListener(Ce.variantUpdate, this.#t));
  }
  #i() {
    if ((this.#e?.destroy(), (this.#e = null), !this.querySelector(".glightbox"))) return;
    const ae = this.dataset.galleryId;
    this.#e = Ke({
      selector: `product-media-lightbox[data-gallery-id="${ae}"] .glightbox`,
      touchNavigation: !0,
      loop: !1,
    });
  }
  #n() {
    requestAnimationFrame(() => this.#i());
  }
}
Ge("product-media-lightbox", Qe);
